import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { DELETE_MOBILE_LISTING, FETCH_PROMOTIONS, MobileListingActionPayload } from 'src/redux/promotionsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteMobileListingFlow(action: PayloadAction<MobileListingActionPayload>): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const { motorbikeId, promotionId } = action.payload
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${motorbikeId}/mobile_listings/${promotionId}`,
      api: 'market-api',
      method: DELETE,
      params: {}
    })
    yield put(FETCH_PROMOTIONS(motorbikeId))
    yield put(SHOW_TOAST({ message: t('my_vehicles.toast_promotion_deleted') }))
  } catch {
    return
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteMobileListingSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_MOBILE_LISTING, DeleteMobileListingFlow)
}
